<div class="modal-header modal-header-2">
  <h2 mat-dialog-title class="pageHeader">Confirmation</h2>
  <button type="button" class="close-button" mat-dialog-close aria-label="Close modal"><span class="ion-android-close" area-hidden="true"></span></button>
</div>
<mat-dialog-content>
  <p class="modal-body">Archive this piece of Evidence?<br> NOTE: This action will remove all links in the text to this document.</p>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="buttonWrapper">
  <button type="button" class="button secondary" (click)="cancel()">Cancel</button>
  <button type="button" class="button" (click)="archiveEvidenceAttachment()">Archive</button>
  </div>
</mat-dialog-actions>
